import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import RFQProposalSidebar from 'components/common/rfq/RFQProposalSidebar';
import { RFQ_PROPOSAL_CARD_DATA } from 'global/checklists-helpers/RFQProposalChecklistHelper';
import RFQChecklistOptionHeader from 'components/common/headers/RFQChecklistOptionHeader';
import { createStyles } from './styles';
import RFQProposalStageCard from './RFQProposalStageCard';

const RFQProposalStages = observer((): JSX.Element => {
  const classes = createStyles();

  const history = useHistory();
  const { periodId } = useParams<{ periodId: string }>();

  const query = useQueryParams();
  const cartId = query.get('cartId') || '';

  if (!periodId) return <></>;

  const {
    rfqProposalChecklistStore: {
      loading,
      checklist,
      productLineIds,
      groupId,
      getProposalChecklist,
      resetProposalInfo,
      getGroupIdToRedirect,
    },
    userStore: { userRoles },
  } = useRootStore();

  const convertedChecklist = toJS(checklist);
  const convertedPLineIds = productLineIds.map((pLineId) => toJS(pLineId)).slice();
  const convertedUserRoles = userRoles.map((role) => toJS(role)).slice();

  useEffect(() => {
    void getProposalChecklist(cartId, periodId);
    return resetProposalInfo;
  }, []);

  const Stages =
    convertedChecklist?.checklistOptions.map((option) => {
      const roleCheck = RFQ_PROPOSAL_CARD_DATA[option.card]?.isAvailable;
      const isStepAvailable = roleCheck ? roleCheck(convertedUserRoles) : true;

      return (
        <RFQProposalStageCard
          key={`${option.card}_${option.completionStatus}`}
          option={option}
          periodId={periodId}
          groupId={groupId || ''}
          defaultProductLineId={convertedPLineIds[0]}
          isAvailable={isStepAvailable}
        />
      );
    }) || [];

  const returnBack = (): void => {
    history.push(`/group/${getGroupIdToRedirect(cartId)}`);
  };

  return (
    <GlobalLayout
      leftSection={<RFQProposalSidebar />}
      rightSection={
        <div className={classes.rightSection}>
          <RFQChecklistOptionHeader
            title="Custom Quote Checklist"
            subtitle="Step by step workflow to complete the response for a custom quote"
            onRedirectBack={returnBack}
          />
          <section className={classes.stagesSection}>
            {convertedChecklist && convertedChecklist.checklistOptions.length > 0 && Stages}
          </section>
          <FormsSpinner display={loading} />
        </div>
      }
    />
  );
});

export default RFQProposalStages;
